import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import CbcMUdyRSGcllExqqINOOKStbpexuBwOZ from "/vercel/path0/pkg/timvir/blocks/ColorBook/samples/basic";
import {Exhibit} from "../../Exhibit";
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "ColorBook"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "<ColorBook>"
      }), " component provides an overview of different color palettes. The palettes are arranged horizontally, which means up to about 8 colors can be comfortable displayed in this book."]
    }), "\n", _jsxs(_components.p, {
      children: ["The user can interact with the book: select individual chapters. How selection is interpreted not handled by this component. In the example below\nupon selecting one of the first two chapters, some extra elements are displayed below the ", _jsx(_components.code, {
        children: "<ColorBook>"
      }), "."]
    }), "\n", _jsx("div", {
      style: {
        marginTop: "5vh"
      },
      children: _jsx(CbcMUdyRSGcllExqqINOOKStbpexuBwOZ, {})
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
